import React from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from 'components/Icons'
import styles from './ErrorState.module.scss'

/**
 * Универсальный error state.
 *   <ErrorState
 *     title="Ошибка загрузки"
 *     description="Не удалось получить данные с сервера"
 *     onRetry={() => fetchData()}
 *   />
 */
const ErrorState = ({
  iconName = 'alert-circle',
  title,
  description,
  onRetry,
  retryLabel,
  variant = 'default',
}) => {
  const { t } = useTranslation('common')
  const resolvedTitle = title ?? t('auto.unvui_errorstate.title', 'Что-то пошло не так')
  const resolvedDescription = description ?? t('auto.unvui_errorstate.description', 'Попробуйте обновить страницу или повторить позже')
  const resolvedRetryLabel = retryLabel ?? t('auto.unvui_errorstate.retry', 'Повторить')
  return (
    <div className={`${styles.error} ${styles[variant] || ''}`} role="alert">
      <div className={styles.iconBox}>
        <Icon name={iconName} size={48} color="var(--color-danger)" strokeWidth={1.5} />
      </div>
      <h3 className={styles.title}>{resolvedTitle}</h3>
      {resolvedDescription && <p className={styles.description}>{resolvedDescription}</p>}
      {onRetry && (
        <button type="button" className={styles.retryBtn} onClick={onRetry}>
          <Icon name="refresh" size={16} color="currentColor" />
          <span>{resolvedRetryLabel}</span>
        </button>
      )}
    </div>
  )
}

export default ErrorState
